// extracted by mini-css-extract-plugin
export default {"container":"To-z","heading":"Uo-z","text":"Vo-z","info":"Wo-z","link":"Xo-z","fullMaxWidth":"Yo-z"};